import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
type Highlight = {
  emoji: string;
  value: string;
  label: string;
  stars?: boolean;
};
const highlights: Highlight[] = [{
  emoji: '🎨',
  value: '150+',
  label: "VEZETETT TEVÉKENYSÉG"
}, {
  emoji: '🎁',
  value: '6',
  label: "AJÁNDEK BÓNUSZ"
}, {
  emoji: '✨',
  value: '100',
  label: "EXTRA TEVÉKENYSÉG"
}, {
  emoji: '⭐',
  value: '4,8',
  label: "VÁSÁRLÓI ÉRTÉKELÉS",
  stars: true
}, {
  emoji: '✏️',
  value: '0',
  label: "SZÜKSÉGES RAJZTUDÁS"
}, {
  emoji: '🛡️',
  value: '30',
  label: "NAPOS GARANCIA"
}];
export function LibraryStats() {
  return <section aria-labelledby="library-title" className="bg-lavender-soft pb-10 pt-14 md:pt-20" data-id="element-144" data-mp="rqxk0ytfo4n3">
      <div className="mx-auto max-w-4xl px-5" data-id="element-145" data-mp="vsj4p6c7ln7u">
        <SectionTitle id="library-title" subtitle="A Művészetterápiás Kézikönyv több mint 150 vezetett tevékenységet, gyakorlatot és gyakorlati eszközt gyűjt egybe, amelyek teret adnak annak, hogy kifejezd, amit érzel — magadnak vagy azoknak, akiket támogatsz. Nincs szükség tapasztalatra." data-id="element-146" data-mp="2tl6m39zfcx6j">
          Egy kreatív könyvtár, amely segít tudatosabban megérteni és kezelni az érzelmeidet
        </SectionTitle>

        <dl className="mx-auto mt-8 grid max-w-2xl grid-cols-2 gap-3 sm:gap-4" data-id="element-147" data-mp="2yyi3aovhi1pz">
          {highlights.map(h => <div key={h.label} className="flex flex-col items-center rounded-3xl bg-white px-3 py-7 text-center shadow-[0_8px_24px_-16px_rgba(140,111,201,0.35)]" data-id="element-148" data-mp="2tzexv3bldthh">
              <span className="text-[1.6rem] leading-none" aria-hidden="true" data-id="element-149" data-mp="3mn18gvj8lydu">
                {h.emoji}
              </span>
              <dd className="mt-4 font-display text-4xl font-extrabold leading-none tracking-tight text-ink" data-id="element-150" data-mp="3hn55mzma0czv">{h.value}</dd>
              {h.stars && <div className="mt-2 flex gap-0.5 text-gold" aria-label="5 csillag" data-id="element-151" data-mp="3coliwwzuyx6g">
                  {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-152" data-mp="2196mbubka7bv" data-mpi={i} />)}
                </div>}
              <dt className="order-last mt-3 text-[15px] font-bold leading-snug text-body" data-id="element-153" data-mp="tbaltlq1foag">{h.label}</dt>
            </div>)}
        </dl>
      </div>
    </section>;
}